import { Grid } from '@mui/material';
import { RoutalLoader, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';

import { useRetrieveActiveProject } from '../../../../../hooks/project/useRetrieveActiveProject';
import { useCreateStops } from '../../../../../hooks/stop/useCreateStops';
import { StopMapper } from '../../../../../mappers/stop/StopMapper';
import Text from '../../../../../react-components/Text';
import { CreateStopsList } from './fields/CreateStopsList';

interface GeocodeAddressesProps {
  createStopsList: CreateStopsList;
  // stops: Stop[];
  onComplete: () => void;
}

export const UploadData = ({ createStopsList, onComplete }: GeocodeAddressesProps) => {
  const { data: activeProject } = useRetrieveActiveProject();
  const { run: createStops, isLoading, error, success } = useCreateStops();

  useEffect(() => {
    if (activeProject?.custom_fields) {
      createStops({
        stops: createStopsList.getStops().map((stop) => StopMapper.toDomain(stop, activeProject.custom_fields!)),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (success) {
      onComplete();
    }
  }, [onComplete, success]);

  return (
    <Grid container style={{ width: `100%` }} alignItems={`center`} justifyContent={`center`}>
      {isLoading && (
        <Grid container alignItems={`center`} flexDirection={`column`}>
          <RoutalLoader />
          <VSpacer small />
          <Text variant="label" intlId={`plans.dialogs.upload_stops.upload_data.loading.text`} />
        </Grid>
      )}
      {error && (
        <Grid container alignItems={`center`} flexDirection={`column`}>
          <Text variant="h5" intlId={`plans.dialogs.upload_stops.upload_data.unknown_error.title`} />
          <VSpacer small />
          <Text intlId={`plans.dialogs.upload_stops.upload_data.unknown_error.text`} />
          <VSpacer small />
          <Text variant="label">{error}</Text>
        </Grid>
      )}
    </Grid>
  );
};
